export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14433.20a990dd.jpg";